<div class="digit-wrapper" [ngClass]="digitClass" [class.duplicate]="duplicate">
  <div class="digit" [style.background-position-y]="digit>=0? digit*size + '%' : '-50%'"
    [ngStyle]="{'background-image': !isNumber? 'url('+codification.image+')' : ''}" [class]="state"
    (click)="digitClick($event,digit)">
    <span *ngIf="isNumber" (click)="digitClick($event, digit)">{{digit>=0? digit : "-"}}</span>
    <div class="border-line" *ngIf="selected"></div>
  </div>
</div>
